export function intersect<T>(arr1: Array<T>, arr2: Array<T>): T[] {
  return arr1.filter((value) => arr2.includes(value));
}

export function intersectExists<T>(arr1: Array<T>, arr2: Array<T>) {
  return intersect(arr1, arr2).length > 0;
}
